@if (!initialized) {
    <!-- no content while loading, avoid potential flicker -->
} @else if (!isAdmin) {
    <p data-testid="settings-admin-only-error">{{ "settings_no_admin_error_message" | translate }}</p>
} @else {
    <div class="center-content-area">
        <router-outlet></router-outlet>
    </div>
}
